export default __webpack_public_path__ + "static/media/monitor-bus.2c4bb6e7.png";